import { isEmbroideryMode } from '@/utils/params';
import { getImgBaseUrl } from './getImgBaseUrl';
import { stringifyImageParams } from './stringifyImageParams';

const fontPreviewLineHeight = 72;
const fontPreviewLineWidth = 527;
const fontPreviewFontSize = 24;

export function getFontPreviewUrl(fontFamilyIds: string[]) {
  if (!fontFamilyIds.length) {
    return null;
  }

  const params = {
    fontColor: '333333',
    fontFamilyIds: fontFamilyIds.join(':'),
    fontSize: fontPreviewFontSize,
    lineHeight: fontPreviewLineHeight,
    lineWidth: fontPreviewLineWidth,
  };
  // re-decode ':' again because image-server uses it as the id delimiter
  const query = stringifyImageParams(params, '&');
  return `${getImgBaseUrl()}/shops/0/fonts${query}`;
}

const getProperFontPreviewBackgroundPosition = (totalFontCount: number, index: number) => {
  const singleGap = fontPreviewLineHeight - fontPreviewFontSize;
  const textItemsize = index * fontPreviewFontSize;
  const totalGap = index * singleGap + singleGap / 2;
  const offset = textItemsize + totalGap;
  return `${-offset / 1.5}px`;
};

const getSophisticatedFontPreviewBackgroundPosition = (totalFontCount: number, index: number) => {
  // highly sophisticated magic done by image server which messes up line height if not taken into account
  const scalingFactor =
    (totalFontCount * fontPreviewLineHeight) /
    ((totalFontCount + 1) * fontPreviewLineHeight - fontPreviewFontSize);
  const absoluteOffset = -index * scalingFactor * fontPreviewLineHeight - fontPreviewFontSize;
  return `${absoluteOffset / 1.5}px`;
};

export const getFontPreviewBackgroundPosition = (totalFontCount: number, index: number) => {
  // for the short list of embroidery fonts we need to use an adjusted (easier) way to calculate
  // the correct background position of the font preview
  // However: this easier will NOT work with the normal CYO font list as the gap between the fonts seems to differ
  // because certain fonts (e.g. CUTTER) are not rendered centered - or measured different - and so the further down
  // the list the more the image will deviate from the center.
  if (isEmbroideryMode()) {
    return getProperFontPreviewBackgroundPosition(totalFontCount, index);
  } else {
    return getSophisticatedFontPreviewBackgroundPosition(totalFontCount, index);
  }
};
